import { useEffect, useState } from 'react';

// Como useState, pero el valor sobrevive mientras la pestaña siga abierta:
// sirve para que una tabla conserve sus filtros al entrar en un detalle y volver.
export default function useSessionState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.sessionStorage.getItem(key);
      return stored != null ? JSON.parse(stored) : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* modo privado */ }
  }, [key, value]);

  return [value, setValue];
}
